import { Injectable, Component, Input } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class MyModalService {
  constructor(private modalService: NgbModal ) { }

  confirm(title: string, message: string, okCaption?: string, canselCaption?: string): Promise<boolean> {
    const modalRef = this.modalService.open(MyModalConfirmContent, {centered: true});
    const component = modalRef.componentInstance as MyModalConfirmContent;
    if(component != null) {
      component.title = title;
      component.message = message;
      component.okCaption = okCaption || 'OK';
      component.cancelCaption = canselCaption || 'Cancel';
    }

    const source = new PromiseCompletionSource<boolean>();

    modalRef.result.then(result => {
      source.resolve(true);
    }, reason => {
      source.resolve(false);
    });

    return source.promise;
  }

  message(title: string, message: string, okCaption?: string): Promise<boolean> {
    const modalRef = this.modalService.open(MyModalMessageContent, {centered: true});
    const component = modalRef.componentInstance as MyModalMessageContent;
    if(component != null) {
      component.title = title;
      component.message = message;
      component.okCaption = okCaption || 'OK';
    }

    const source = new PromiseCompletionSource<boolean>();

    modalRef.result.then(result => {
      source.resolve(true);
    }, reason => {
      source.resolve(false);
    });

    return source.promise;
  }

}

class PromiseCompletionSource<T> {
  public readonly promise: Promise<T>;

  private resolver: (x?: T) => void;
  private rejector: (reason?: any) => void;

  constructor() {
    this.promise = new Promise<T>((resolve, reject) => {
      this.resolver = resolve;
      this.rejector = reject;
    });
  }

  public resolve(x: T) {
    if(this.resolver) {
      this.resolver(x);
    }
  }

  public reject(reason?: any) {
    if(this.rejector) {
      this.rejector(reason);
    }
  }
}


@Component({
  template:
  `
<div class="modal-header">
  <h4 class="modal-title">{{title}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('dissmiss')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p>{{message}}</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="activeModal.close('ok')">{{okCaption}}</button>
  <button type="button" class="btn btn-outline-dark" (click)="activeModal.dismiss('cansel')">{{cancelCaption}}</button>
</div>
  `
})
export class MyModalConfirmContent {
  @Input() title: string;
  @Input() message: string;
  @Input() okCaption = 'OK';
  @Input() cancelCaption = 'Cancel';

  constructor(public activeModal: NgbActiveModal) { }
}

@Component({
  template:
  `
<div class="modal-header">
  <h4 class="modal-title">{{title}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('dissmiss')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p>{{message}}</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="activeModal.close('ok')">{{okCaption}}</button>
</div>
  `
})
export class MyModalMessageContent {
  @Input() title: string;
  @Input() message: string;
  @Input() okCaption = 'OK';

  constructor(public activeModal: NgbActiveModal) { }
}